<svg class="statistic-caption mat-caption m-t-16 m-b-16" #studentGradesChartContainer [@fade]></svg>

